import { Application } from '@hotwired/stimulus'

import PackageSelectController from './package_select_controller'
const application = Application.start()
application.register('package-select', PackageSelectController)

